module.exports = __webpack_public_path__ + "static/media/hay.24ac03fc.png";